// @ts-nocheck
import { LayoutDefault } from './LayoutDefault'
import { teasers as T } from '../../../opopular/assets/teasers';
import { PageBlockTypes as p } from '@xprog/prensa/types'

// MancheteComFoto
const LayoutFeatured: p.SlotConfigProps = {
  ...LayoutDefault,
  slotConfig: {
    ...LayoutDefault?.slotConfig,
    Template100: {
      slotLeft: {
        default: [T.TeaserImageLeftSq, T.TeaserImageLeft],
        '1': [T.TeaserImageLeft, T.TeaserImageLeftLg],
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        default: [T.TeaserBackground, T.TeaserBackgroundLg],
      }
    }
  }
}

export { LayoutFeatured }
